import { IonModal, IonItem, IonLabel, IonInput, IonButton } from "@ionic/react";
import "./ModalCambioContrasena.css";

const ModalCambioContraseña = ({
  isOpen,
  usuario,
  setUsuario,
  handlePasswordChange,
  onClose,
}) => {
  return (
    <IonModal isOpen={isOpen} cssClass="custom-modal">
      <div style={{ padding: "20px" }}>
        <h2>Solicitud Cambio Contraseña</h2>
        <IonItem>
          <IonLabel position="stacked">Documento</IonLabel>
          <IonInput
            type="text"
            value={usuario.usuario}
            onIonChange={(e) => {
              let value = e.detail.value || "";
              value = value.replace(/\s+/g, "").replace(/[^0-9]+/g, "");
              setUsuario({ ...usuario, usuario: value });
            }}
          />
        </IonItem>

        <IonItem>
          <IonLabel position="stacked">Email</IonLabel>
          <IonInput
            type="email"
            value={usuario.email}
            onIonChange={(e) => {
              let value = e.detail.value || "";
              value = value.replace(/\s+/g, "").toLowerCase();
              setUsuario({ ...usuario, email: value });
            }}
          />
        </IonItem>
        <br />
        <IonLabel position="stacked" color={"danger"}>
          Se le dará acceso al cambio de contraseña a través de un link a su
          correo electrónico. En caso de no contar con un correo registrado, por
          favor comuníquese con la clínica.
        </IonLabel>
        <br />
        <br />
        <IonButton onClick={handlePasswordChange} color="success">
          Enviar Solicitud
        </IonButton>
        <IonButton onClick={onClose} color="danger">
          Cancelar
        </IonButton>
      </div>
    </IonModal>
  );
};

export default ModalCambioContraseña;
